<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> جستجوی مسافران  </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-md-0 gy-3" [formGroup]="mdl_Search">

        <!-- نام خانوادگی -->
        
        <div class="position-relative col-12 col-md-3 p-2">

            <label class="text-muted"> نام خانوادگی </label>

            <input class="form-control p-2 text-center"

                placeholder="نام خانوادگی مسافر را وارد کنید"
            
                formControlName="strFamily">

        </div>

        <!-- موبایل -->
        
        <div class="position-relative col-12 col-md-3 p-2">

            <label class="text-muted"> موبایل </label>

            <input class="form-control p-2 text-center"

                maxlength="11"

                placeholder="شماره موبایل مسافر را وارد کنید"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="strMobile">

        </div>

        <!-- وضعیت -->
        
        <div class="position-relative col-12 col-md-2 p-2">

            <label class="mb-2 text-muted"> وضعیت </label>

            <select class="form-select p-2" formControlName="tiAvtive">

                <option class="text-center" value="-1"> غیرفعال </option>

                <option class="text-center" [value]="0"> فعال </option>

            </select>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent py-2">

            <button class="btn btn-primary w-100" (click)="search_Passenger()"> جستجو </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent py-2">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')"> 

                خروجی اکسل
                
            </button>

        </div>
        
    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

        <div class="section border border-2 mt-2" style="height:calc(100vh - 230px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                <thead>
            
                    <tr class="">
        
                        <th class="text-center"> # </th>
    
                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> نام </th>

                        <th class="text-center"> نام خانوادگی </th>

                        <th class="text-center"> موبایل </th>

                        <th class="text-center"> تاریخ ثبت نام </th>

                        <th class="text-center"> جنسیت </th>

                        <th class="text-center"> شهر </th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Passenger;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class=""> 

                            <i class="fa fa-eye fa-lg pointer" aria-hidden="true"></i>

                            <i class="fa fa-map-pin mx-3 fa-lg text-primary pointer" title="موقعیت" (click)="showMap(item)"></i>

                            <i  class="fa fa-lg pointer" (click)="activation_User(item,i)"

                                [ngClass]="item.bActive ? 'fa-ban text-danger' : 'fa-check-circle text-success' "
                                
                                [title]="item.bActive ? 'غیرفعال' : 'فعالسازی' ">
                            
                            </i>

    
                        </td>

                        <td [innerHTML]="highlightText(item.strName,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strFamily,searchTerm.value)  | faNum"> </td>

                        <td> {{ item.strMobile | faNum }} </td>

                        <td dir="ltr"> {{ item.strRegisterDate | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strSexComment,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strCityName,searchTerm.value)  | faNum"> </td>

                    </tr>

                </tbody>
    
            </table>

        </div>

    </div>


</main>